import * as React from 'react';
import { observer } from 'mobx-react';

import { useRootStore, useRouterStore, useUserStore } from 'stores/index';
import { LoadingStage } from 'shared/entities/meta';
import { PopupMenuItemBorder } from 'shared/components/list';
import BaseItem from 'shared/newComponents/list/BaseItem';
import { ComponentType } from 'shared/entities/components/Component';
import { useLocal } from 'shared/entities/common/hooks';
import { ManagersRolesStore } from 'stores/managers/managersRolesStore';
import { LogoutIcon } from 'shared/newComponents/icons';
import {
  TypographyColor,
  TypographySize
} from 'shared/newEntities/components/Typography';
import LoaderSpinner, {
  LoadingSpinnerColor
} from 'shared/components/animations/LoaderSpinner';
import { IconSize } from 'shared/entities/components/Icon';

import UserInfo from './UserInfo';

import './PopupContent.modules.scss';

type Props = {
  content: React.ReactNode;
};

const PopupContent: React.FC<Props> = ({ content }: Props) => {
  const userStore = useUserStore();
  const rootStore = useRootStore();
  const managerRolesStore = useLocal(() => new ManagersRolesStore(rootStore));
  const routerStore = useRouterStore();

  React.useEffect(() => {
    managerRolesStore.load();
  }, []);

  const handleLogout = React.useCallback(async () => {
    const { isError } = await userStore.logout();

    if (!isError) {
      routerStore.changeToAuthDomain();
    }
  }, []);

  return (
    <div styleName="content">
      {userStore.user && (
        <UserInfo name={userStore.user.name} email={userStore.user.email} />
      )}
      {content}
      <BaseItem
        styleName="exit"
        border={PopupMenuItemBorder.TOP_BORDER}
        title={(t) => t('UserPopup.exit', { ns: 'newContainers' })}
        titleSize={TypographySize.s}
        titleColor={TypographyColor.secondary}
        size="s"
        left={
          <div styleName="exit__icon">
            {userStore.logoutStage === LoadingStage.LOADING ? (
              <LoaderSpinner color={LoadingSpinnerColor.gray} />
            ) : (
              <LogoutIcon iconSize={IconSize.S} />
            )}
          </div>
        }
        type={ComponentType.div}
        onClick={handleLogout}
      />
    </div>
  );
};

export default observer(PopupContent);
